import { createSelector } from 'reselect';

export const getStationStatus = (state) => state.stationStatus;

export const getLocationEquipmentItems = createSelector(
  getStationStatus,
  ({ items }) => items
);

export const getSelectedLocation = createSelector(
  getStationStatus,
  ({ selectedLocation }) => selectedLocation
);

export const getSelectedEquipment = createSelector(
  getStationStatus,
  ({ selectedEquipment }) => selectedEquipment
);
